import { __extends } from "tslib";
import { deepMix } from '@antv/util';
import { Plot } from '../../core/plot';
import { adaptor } from './adaptor';
var Rose = /** @class */ (function (_super) {
    __extends(Rose, _super);
    function Rose() {
        var _this = _super !== null && _super.apply(this, arguments) || this;
        /** 玫瑰图 */
        _this.type = 'rose';
        return _this;
    }
    /**
     * 获取默认的 options 配置项
     */
    Rose.prototype.getDefaultOptions = function () {
        return deepMix({}, _super.prototype.getDefaultOptions.call(this), {
            xAxis: false,
            yAxis: false,
            legend: {
                position: 'right',
                offsetX: -10,
            },
            sectorStyle: {
                stroke: '#fff',
                lineWidth: 1,
            },
            label: {
                layout: {
                    type: 'limit-in-shape',
                },
            },
        });
    };
    /**
     * 获取 玫瑰图 的适配器
     */
    Rose.prototype.getSchemaAdaptor = function () {
        return adaptor;
    };
    return Rose;
}(Plot));
export { Rose };
//# sourceMappingURL=index.js.map